// extracted by mini-css-extract-plugin
module.exports =  {"root":"ContextMenu-module__root--nETLD","item":"ContextMenu-module__item--kaQXN","disabled":"ContextMenu-module__disabled--Uyv11"};